/*	
	Modal Content to display in ModalAppInfo
	Date created: 3/11/2021; Last Update: 3/11/2021
*/

import React from "react";
//import AppConfig from '../data/appConfig.js';

const ModalContent = () => {
	return (
		<div>
			<h3>消災延壽光明燈 登記表 說明</h3>
			<h4>必填欄 Required Fields</h4>
			<ul>
				<li><h5>續燈 Renew Light</h5>
					<ul>
						<li>燈號 Light ID: Rxx-xx (R01-01) or Lxx-xx (L01-01)</li>
					</ul>
				</li>
				<li><h5>新燈 New Light</h5>
					<ul>
						<li>點燈受益人（燈上名字）至少填一人名<br />
						Name(s) on the New Light: at least one name</li>
						<li>點燈人
							<ul>
								<li>至少填一姓名, 不論是中文或英文姓名.<br />
								At least one name, be it English or Chinese.</li>	
								<li>至少填一電話號碼, 不論是手機還是座機.<br />
								At least one phone number, be it Cell or Home.</li>
								<li>電郵 Email</li>
								<li>地址 Address</li>
								<li>城市 City</li>
								<li>州 State</li>
								<li>區碼 Zip Code</li>
							</ul>
						</li>
						<li>連絡人
							<ul>
								<li>如果連絡人就是點燈人, 則不用填<br />
								If the Contact is the Donor, nothing is required.</li>
								<li>如果連絡人不是點燈人, 則姓名, 電郵, 電話都得填.<br />
								If the Contact is not the Donor, all 3 fields are required.
								</li>
							</ul>
						</li>
					</ul>
				</li>
			</ul>
		</div>
	);
};

export default ModalContent;
